import { useState, useEffect } from 'react';


export default function EventImage (props: { src: string, checkSize: boolean }) {

	const [imgMaxHeight, setImgMaxHeight] = useState<number>(600);
	const [finalSrc, setFinalSrc] = useState(props.src);

	useEffect( () => {
		setImgMaxHeight(window.innerHeight/100*75);

		const checkImageSize = async () => {
			try {
				const res = await fetch(props.src, { method: 'HEAD' });
				if ( parseInt(res.headers.get('content-length')) < 200 )
					setFinalSrc('/disco-icon.png');
			}
			catch {
				console.log("HEAD request probably blocked");
			}
		};
		if (props.checkSize)
			checkImageSize();
	}, [props.src]);

	return <img src={finalSrc} alt='' style={{ maxHeight: `${imgMaxHeight}px` }} />;
};